// extracted by mini-css-extract-plugin
export var centerText = "_83-8";
export var container = "_83-0";
export var doughnutContainer = "_83-7";
export var legend = "_83-a";
export var legendItemColorDisplay = "_83-b";
export var legendItemLabel = "_83-d";
export var legendItemValue = "_83-c";
export var lg = "_83-5";
export var maxWidth = "_83-9";
export var md = "_83-4";
export var responsive = "_83-6";
export var sm = "_83-3";
export var xs = "_83-2";
export var xxs = "_83-1";